"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractRelayerFee_1 = require("./AbstractRelayerFee");
const ArbitrumRelayerFee_1 = require("./ArbitrumRelayerFee");
const ethers_1 = require("ethers");
const models_1 = require("../models");
const LineaRelayerFee_1 = require("./LineaRelayerFee");
const RelayerFees = {
    [models_1.Chain.Arbitrum.slug]: ArbitrumRelayerFee_1.ArbitrumRelayerFee,
    [models_1.Chain.Nova.slug]: ArbitrumRelayerFee_1.ArbitrumRelayerFee,
    [models_1.Chain.Linea.slug]: LineaRelayerFee_1.LineaRelayerFee
};
class RelayerFee extends AbstractRelayerFee_1.AbstractRelayerFee {
    constructor(network, chain, token, configRelayerFee) {
        super(network, chain, token, configRelayerFee);
        const relayerFeeConstructor = RelayerFees === null || RelayerFees === void 0 ? void 0 : RelayerFees[chain];
        if (!relayerFeeConstructor) {
            throw new Error(`Relayer fee not implemented for network ${network}, chain ${chain}, token ${token}`);
        }
        this.relayerFee = new relayerFeeConstructor(network, chain, token, this.configRelayerFeeWei);
    }
    async getRelayCost() {
        // TODO: Remove redundancy
        try {
            return this.relayerFee.getRelayCost();
        }
        catch (_a) {
            return ethers_1.BigNumber.from(0);
        }
    }
}
exports.default = RelayerFee;
